import AlertTemplate from './alert-template.component';

export default AlertTemplate;
